import { RoleEnum } from './user';

export enum LogLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export enum DocDirection {
  UPLOAD = 'UPLOAD',
  DOWNLOAD = 'DOWNLOAD',
}

export interface IDocumentLog {
  id: string;
  createdAt: Date;
  level: LogLevel;
  details: {
    id?: string;
    name?: string;
    role?: RoleEnum;
    email?: string;
    userId?: string;
    direction?: DocDirection;
    transactionId?: string;
    transactionRef?: string;
    size?: number;
    message?: string;
  };
}
